/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export function makeReference(id) {
    return { __ref: String(id) };
}
//# sourceMappingURL=makeReference.js.map
